import script from "./OrganizationInformationTile.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationInformationTile.vue?vue&type=script&setup=true&lang=js"

export default script